import type { PostHog } from "posthog-js";

/**
 * PostHog bajo demanda (31-10-2026): se descargaba para todo el mundo (64 KB
 * comprimidos) aunque solo se use con consentimiento. Ahora el paquete se pide
 * al aceptar las cookies; hasta entonces `posthogLoaded()` es false y nadie lo
 * llama. Al terminar de iniciarse se lanza `posthog-ready` en window.
 */
let instance: PostHog | null = null;

export async function loadPosthog(): Promise<PostHog> {
  if (!instance) instance = (await import("posthog-js")).default;
  return instance;
}

export function posthogLoaded(): boolean {
  return Boolean(instance?.__loaded);
}

/** La instancia ya iniciada: solo tras comprobar `posthogLoaded()`. */
export function posthog(): PostHog {
  return instance!;
}
